import { InMemoryStorage } from "./InMemoryStorage";
import { StorageType } from "./types";

export function getBrowserStorage(type: StorageType): Storage {
  try {
    // Reading these can throw (Safari private mode, sandboxed iframes) but can also just be absent —
    // Node 26 defines its own `localStorage` global that reads as `undefined` without
    // `--localstorage-file`, shadowing the one happy-dom installs. Returning that would break the
    // `Storage` return type, and the safe wrapper around it swallows the resulting TypeErrors, so
    // reads return null and writes vanish. Treat absent like thrown. (`Storage | undefined` because
    // lib.dom types these as always present.)
    if (type === "local") {
      // eslint-disable-next-line @web-monorepo/no-browser-storage -- this is the sanctioned accessor the rest of the app goes through
      const storage: Storage | undefined = window.localStorage;
      if (storage) {
        return storage;
      }
    } else if (type === "session") {
      // eslint-disable-next-line @web-monorepo/no-browser-storage -- this is the sanctioned accessor the rest of the app goes through
      const storage: Storage | undefined = window.sessionStorage;
      if (storage) {
        return storage;
      }
    } else {
      throw new Error("Unsupported storage type");
    }
    // eslint-disable-next-line no-catch-all/no-catch-all
  } catch {
    /* empty */
  }

  // eslint-disable-next-line no-console
  console.warn(`${type} storage is disabled, using in-memory storage`);
  return new InMemoryStorage();
}
